import React from "react";
import Header from "../../components/Layouts/AppHeader/Header";

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header merchantLogoUrl="" />
      <div className="flex-1">{children}</div>
    </div>
  );
};

export default MainLayout;
